export default __webpack_public_path__ + "static/media/iron.fc074a26.svg";